/* eslint-disable indent */
import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

interface NavTabsProps {
  id: string;
  case: number;
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
  borderRadius: '12px 12px 0 0', // Alterado: radius apenas na parte superior
  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
  marginBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: '48px',
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
    borderRadius: '3px 3px 0 0',
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.95rem',
    minHeight: '48px',
    color: theme.palette.text.secondary,
    borderRadius: '12px 12px 0 0', // Adicionado: radius nas tabs
    '&.Mui-selected': {
      color: theme.palette.primary.dark,
      fontWeight: 600,
      backgroundColor: theme.palette.background.paper, // Mantém fundo consistente
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.dark,
    },
  },
}));

export default function NavTabs({ id, case: initialCase = 0 }: NavTabsProps) {
  const [value, setValue] = React.useState(initialCase);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    // Verifica qual rota está ativa
    if (location.pathname.includes('dashboard')) {
      setValue(1);
    } else if (location.pathname.includes('movimento')) {
      setValue(2);
    } else {
      setValue(0);
    }
  }, [location.pathname]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate(`/produto/${id}`);
        break;
      case 1:
        navigate(`/produto/dashboard/${id}`);
        break;
      case 2:
        navigate(`/produto/movimento/${id}`);
        break;
      default:
        break;
    }
  };

  return (
    <StyledPaper elevation={0}>
      <StyledTabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        aria-label="nav tabs"
      >
        <Tab
          label={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>Detalhes do Produto</span>
            </Box>
          }
        />
        <Tab
          label={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>Dashboard</span>
            </Box>
          }
        />
        <Tab
          label={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>Movimento</span>
            </Box>
          }
        />
      </StyledTabs>
    </StyledPaper>
  );
}